module.exports = __webpack_public_path__ + "media/images/front/icon_fb-e556a259f682824dcc7b8153c5673f95.png";